import PopupHeader from "@builder/components/app/Popup/PopupHeader";
import TextInput from "@builder/components/general/TextInput";
import { useState } from "react";
import "./style.scss";
import FinalIconLibrary from "@builder/components/app/Popup/popups/Icons/FinalLibrary";
import { useAppSelector } from "@builder/store/store";

const libraryMap = [
    { id: "final", label: "Final", content: (search?: string, path?: (string | number)[]) => <FinalIconLibrary search={search} path={path} /> }
    // { id: "mui", label: "MUI", content: (search?: string) => <p>{search}</p> }
];

const IconPopup = () => {
    const path = useAppSelector(state => state.popup.iconState);
    const [iconSearch, setIconSearch] = useState<string>();
    const [currentTab, setCurrentTab] = useState<{ id: string; label: string; content: (search?: string, path?: (string | number)[]) => JSX.Element }>(
        libraryMap[0]
    );
    return (
        <div className="icon-popup">
            <PopupHeader src="/icon-icon.svg" title="Icons">
                <div className="search-wrapper">
                    <TextInput
                        value={iconSearch}
                        placeholder="Search for icons"
                        callback={(value: string) => setIconSearch(value)}
                        icon={{ src: "/search-icon.svg" }}
                    />
                </div>
            </PopupHeader>
            <div className="icon-popup-body">
                <div className="left-sidebar">
                    {libraryMap.map(library => (
                        <label key={library.id}>
                            <input type="radio" checked={currentTab.id === library.id} onChange={() => setCurrentTab(library)} readOnly />
                            <div className="custom-radio">
                                <p>{library.label}</p>
                            </div>
                        </label>
                    ))}
                </div>
                <div className="main-content">{currentTab.content(iconSearch, path ? path : undefined)}</div>
            </div>
        </div>
    );
};

export default IconPopup;
